import { KaizodoSearchParam, KaizodoDataSet } from "../types/WebData";
import API from "./api";
import * as MESSAGE from "../const/message";
import { HTTP_STATUS_CODE } from "../const/index";

/**
 * kaizodoテーブルAPI get
 *
 * @param {number} kaizodoId
 */
export const getSearchKaizodoId = async (kaizodoId: number) => {
  const result = await API.get(`/cms-api/kaizodo/id`, { params: { id: kaizodoId } })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return { isError: true, message: MESSAGE.SYSTEM_ERROR, data: [] };
    });
  return result;
};

/**
 * kaizodoテーブルAPI
 * 解像度情報検索
 *
 * @param {KaizodoSearchParam} searchParam
 * @return {*} 
 */
export const postSearchKaizodo = async (searchParam: KaizodoSearchParam) => {
  const result = await API.post(`/cms-api/kaizodo/search`, searchParam)
    .then((res) => {
      return { data: res.data.data, isError: false, message: "" };
    })
    .catch((error) => {
      return { data: [], isError: true, message: MESSAGE.SYSTEM_ERROR };
    });
  return result;
};

/**
 * kaizodoテーブルAPI 更新
 *
 * @param {KaizodoDataSet} postData
 */
export const updateKaizodo = async (postData: KaizodoDataSet) => {
  if (postData.id === 0) {
    // insert
    const result = await API.post("/cms-api/kaizodo", postData)
      .then((res) => {
        return { isError: false, message: MESSAGE.TOROKU_SEIKO };
      })
      .catch((error) => {
        return { isError: true, message: MESSAGE.SYSTEM_ERROR };
      });
    return result;
  } else {
    // update
    const result = await API.put("/cms-api/kaizodo/id", postData)
      .then((res) => {
        return { isError: false, message: MESSAGE.KOSHIN_SEIKO };
      })
      .catch((error) => {
        const status = error.response.status;
        const message = status === HTTP_STATUS_CODE.CONFLICT_ERROR ? MESSAGE.CONFLICT_ERROR : MESSAGE.SYSTEM_ERROR;
        return { isError: true, message: message, data: [] };
      });
    return result;
  }
};

/**
 * kaizodoテーブルAPI del_flg更新
 *
 * @param {number} id
 * @param {boolean} del_flg
 */
export const deleteKaizodo = async (id: number, del_flg: boolean) => {
  const result = await API.put("/cms-api/kaizodo/delete", { id: id, del_flg: del_flg })
    .then((res) => {
      return { isError: false, message: "" };
    })
    .catch((error) => {
      return { isError: true, message: MESSAGE.SYSTEM_ERROR, data: [] };
    });
  return result;
};